import React, { useContext, useEffect, useState } from "react"
import { Col, Container, Row } from 'reactstrap';
import Logs from "../../../c/logs"
import { APIGet, APIDelete, APIPost } from "../../../API"
import { AssignWhistle, ChangeWhistleStatus, ShareWhistle } from "../../../c/whistleactions"
import DashboardContext from "../../../contexts/dashboardContext"
import { CgArrowLongLeft } from "react-icons/cg"
import { Modal } from "reactstrap"
import { T, TraksConsumer } from "../../../traks"
import { RenderIf } from "../../../helpers/RenderIf"
import { AlertModal } from "../../../c/Modals"
import { Loading } from "../../../c/Loading/Loading"
import MeContext from "../../../MeContext";
import UploadAndDownload from "../../../c/UploadAndDownload";
import { Messages } from "../../../c/Messages"
import { extractMessages } from "../../../helpers/cleanLogs"
import { WhistleContent } from "../../../c/Whistle"
import WhistleInfo from "./WhistleInfo"
import { CollapsibleContainer } from "../../../c/CollapsibleContainer"
import WhistlesContext from "../../../contexts/whistlesContext"
import WhistleAudioContent from "../../../c/Whistle/AudioContent"

const WhistleHeader = ({ children = null }) => {
	const { setActiveTab } = useContext(DashboardContext)

	return (<>
		<div className="my-5 d-flex flex-row justify-content-between">
			<div>
				<button
					className="btn light_grey_on_dark"
					onClick={() => setActiveTab("Whistles")}
				>
					<div className="d-flex align-items-center">
						<CgArrowLongLeft className="me-3 primary fw_600" />
						<T>Back</T>
						<span className="d-none d-lg-block inline">&nbsp;<T>to entries list</T></span>
					</div>
				</button>
			</div>
			<div className="d-flex flex-row">
				{children}
			</div>
		</div>
	</>)
}

const HeaderButton = ({ children, className = "", onClick }) => {
	const classList = `btn fw_600 sibilus_border me-4 hoverable-grey${" " + className}`

	return (
		<div>
			<button className={classList} onClick={onClick}>
				{children}
			</button>
		</div>
	)
}

const ActionModal = ({ children, isOpen, toggle }) => {
	return (
		<Modal isOpen={isOpen} toggle={toggle} className={"modals"}>
			<div className="p-5">
				{children}
			</div>
		</Modal>
	)
}


export const Whistle = (props) => {
	const { me } = useContext(MeContext)
	const [whistle, setWhistle] = useState(undefined)
	const [audioContentUrl, setAudioContentUrl] = useState(undefined)
	const [messages, setMessages] = useState([])
	const [alertType, setAlertType] = useState({ type: "", text: "" })
	const [showAlert, setShowAlert] = useState(false)
	const [showLoading, setShowLoading] = useState(false)
	const [editStatusOpen, setEditStatusOpen] = useState(false)
	const [showLogs, setShowLogs] = useState(false)
	const [shareWhistleOpen, setShareWhistlesOpen] = useState(false)
	const [assignWhistleOpen, setAssignWhistlesOpen] = useState(false)
	const { getCategories } = useContext(WhistlesContext)
	const { openWhistle } = useContext(DashboardContext)
	const [files, setFiles] = useState([])

	const getWhistle = () => {
		setShowLoading(true)
		let resource = 'whistles/' + openWhistle;
		APIGet(resource).then((res) => {
			setWhistle(res.data.whistle);
			if (res.data.whistle["audioContent"])
				setAudioContentUrl(res.data.whistle.audioContent.url)
			setShowLoading(false)
		}).catch((err) => {
			setShowLoading(false)
			setAlertType({ type: "error", text: err.response.data })
			setShowAlert(true)
		});
	};


	const deleteMessage = (messageId) => {
		const whistleId = whistle.id
		const accessId = whistle["whistle_access_id"] || null
		setShowLoading(true)
		const resource = `whistles/${whistleId}/log/${messageId}`
		APIDelete(resource, {action: "delete_log", access_id: accessId}).then(res => {
			setShowLoading(false)
			setMessages(prevS => prevS.filter(m => m.id !== messageId))
		}).catch(err => {
			setAlertType({ type: "error", text: err.response.data })
			setShowAlert(true)
		})
	}

	const setCategory = (category, action = "add") => {
		const whistleId = whistle.id
		const accessId = whistle["whistle_access_id"] || null
		let newCateories = []
		if (action === "add") {
			newCateories = [...whistle.categories, category]
			setWhistle({ ...whistle, categories: [...whistle.categories, category] })
		} else {
			if (!category) {
				let newCategories = categories
				newCategories.pop()
				setWhistle({ ...whistle, categories: newCategories })
			} else {
				newCateories = whistle.categories.filter(el => el !== category)
				setWhistle({ ...whistle, categories: newCateories })
			}
		}
		APIPost("whistles/" + whistleId + "/categories", { action: "change_category", categories: newCateories, access_id: accessId }).then(res => {
			console.log(res)
		}).catch(err => {
			setAlertType({ type: "error", text: err.response.data })
			setShowAlert(true)
			console.log(err)
		})
	}

	const handleRefresh = () => {
		setWhistle(undefined)
		getWhistle()
	}

	useEffect(() => {
		getWhistle()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])


	useEffect(() => {
		if (whistle !== undefined)
			setMessages(extractMessages([...whistle.comments, ...whistle.messages]))
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [whistle])


	if (whistle === undefined)
		return (
			<>
				<WhistleHeader />
				<Loading
					showLoading={showLoading}
					inFront
				/>
				<AlertModal
					isShowing={showAlert}
					setIsShowing={setShowAlert}
					type={alertType.type}
					text={alertType.text}
				/>
			</>
		)

	const categories = whistle.categories

	return (<>
		<RenderIf condition={whistle}>
			<Container fluid>
				<Row>
					<Col>
						<WhistleHeader>
							<HeaderButton onClick={() => setAssignWhistlesOpen(true)}>
								<T>Assign whistle</T>
							</HeaderButton>
							<HeaderButton onClick={() => setShareWhistlesOpen(true)}>
								<T>Share</T>
							</HeaderButton>
							<HeaderButton onClick={() => setShowLogs(!showLogs)}>
								<T>Logs</T>
							</HeaderButton>
							<HeaderButton onClick={() => setEditStatusOpen(true)}>
								<T>Change Status</T>
							</HeaderButton>
							<div className="cursor_pointer btn" onClick={() => handleRefresh()}>
								<img src="https://static.sibilus.eu/gfx/reload-icon-0.svg" alt="reload-icon" style={{ width: "25px" }} />
							</div>
						</WhistleHeader>
					</Col>
				</Row>
				<Row>
					<Col xs={12} lg={8}>
						<WhistleInfo
							whistle={whistle}
							allCategories={getCategories()}
							categories={categories}
							setCategories={setCategory}
						/>
						<RenderIf condition={whistle.status !== "deleted"}>
							<CollapsibleContainer className="mt-5">
								<div className="fw_700">
									<T>Entry</T>
								</div>
								<div>
									<WhistleContent
										content={whistle.content}
									/>
									<RenderIf condition={audioContentUrl !== undefined}>
										<div className="my-5">
											<WhistleAudioContent
												audioContentURL={audioContentUrl}
											/>
										</div>
									</RenderIf>
								</div>
							</CollapsibleContainer>
						</RenderIf>
						<Messages
							className="mt-5"
							messages={messages}
							setMessages={setMessages}
							whistle={whistle}
							showMessageChoice={true}
							deleteMessage={deleteMessage}
						/>
					</Col>
					<RenderIf condition={whistle.status !== "deleted"}>
						<Col md={12} lg={4}>
							<UploadAndDownload
								setFiles={setFiles}
								files={files}
								whistle={whistle}
								screenName={me.screen_name}
								updateWhistle={getWhistle}
							/>
						</Col>
					</RenderIf>
				</Row>
			</Container>
			<ActionModal isOpen={editStatusOpen} toggle={() => setEditStatusOpen(!editStatusOpen)}>
				<ChangeWhistleStatus
					setEditStatusOpen={setEditStatusOpen}
					whistle={whistle}
					setWhistle={setWhistle}
				/>
			</ActionModal>
			<ActionModal isOpen={showLogs} toggle={() => setShowLogs(!showLogs)}>
				<Logs
					whistle={whistle}
				/>
			</ActionModal>
			<ActionModal isOpen={shareWhistleOpen} toggle={() => setShareWhistlesOpen(!shareWhistleOpen)}>
				<TraksConsumer>
					<ShareWhistle
						whistle={whistle}
					/>
				</TraksConsumer>
			</ActionModal>
			<ActionModal isOpen={assignWhistleOpen} toggle={() => setAssignWhistlesOpen(!assignWhistleOpen)}>
				<TraksConsumer>
					<AssignWhistle
						whistle={whistle}
					/>
				</TraksConsumer>
			</ActionModal>
		</RenderIf>
		<AlertModal
			isShowing={showAlert}
			setIsShowing={setShowAlert}
			type={alertType.type}
			text={alertType.text}
		/>
		<Loading
			showLoading={showLoading}
			inFront
			overlay
		/>
	</>)
}
